<div class="main-card error-card" fxLayout="column" fxLayoutAlign="center start">
  <div class="error-code">403</div>
  <div class="error-message">{{'NO_ACCESS.MESSAGE' | translate}}</div>
</div>